import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { isTenantAdmin } from '../../models/enums/user-role.enum';
import { AuthService } from '../../services/auth.service';

/** `/settings` lands on the first page the role may open: Business for the owner, Personal details for staff. */
export const settingsLandingGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(AuthService).currentProfile$.pipe(
    take(1),
    map((profile) => router.createUrlTree(['/settings', profile && isTenantAdmin(profile.role) ? 'business' : 'account'])),
  );
};
